import * as yup from 'yup';
import { PageMode } from 'civil-status/view-models/page-mode';
import { ObjectShape } from 'yup/lib/object';
import { civilUnionSchemaObject } from 'shell/constants/create-schema-civil-union';

const createSchema = (mode: PageMode): yup.ObjectSchema<ObjectShape> => {
  let schemaObject: ObjectShape = {};

  if (mode === PageMode.Edit) {
    schemaObject = civilUnionSchemaObject;
  }

  return yup.object().shape(schemaObject);
};

export default createSchema;
